import React from "react";

function Comingsoon() {
  return (
    <div className="comingsoon-wrap">
      <div className="title">Coming Soon</div>
      <div className="subtitle">We are working on something amazing!</div>
      <div className="circle-container">
        <div className="circle"></div>
        <div className="circle"></div>
        <div className="circle"></div>
      </div>
    </div>
  );
}

export default Comingsoon;